import React, { useEffect, useState, useRef } from "react";
import { ls } from "../../../locale";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";

import { getAgentPath, isInAppBrowser } from "../../../helpers";
import { numberFormatter } from "../../../helpers";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import StatusBar from "../../../components/StatusBar";
import SeatSelection from "../../../components/SeatSelection";

import { bookingActions } from "../../../state/ducks/booking";
import { wciActions } from "../../../state/ducks/wci";

import "./index.scss";
import Backdrop from "../../../components/Backdrop";

import { jumpTo } from "../../../helpers";
import { MessageBox } from "./MessageBox";
import { isAllSeatSelected } from "../helpers";

function SeatsPage({ booking, bookingSummary, getBookingWithSummary, getSeatMap, assignSeat, clearSeat, confirm }) {

  const [seatMaps, setSeatMaps] = useState([]);

  const messageBox = useRef();

  useEffect(() => {
    getSeatMap().then(response => {
      setSeatMaps(response);
    });
    getBookingWithSummary();
  }, []);

  const onAssignSeat = (data) => {
    return assignSeat(data)
      .then(() => getBookingWithSummary());
  }

  const onClearSeat = (data) => {
    return clearSeat(data)
      .then(() => getBookingWithSummary());
  }

  const continueToCheckout = () => {
    getBookingWithSummary().then(({ booking }) => {
      if (!booking.pnr) return;

      if (booking.reservationBalance === 0) {
        // check in
        confirm().then(response => {
          if (response.pnr) jumpTo(getAgentPath() + "/wci/confirmation", { from: 'checkout' });
        })
      }
      else {
        jumpTo(getAgentPath() + "/checkout");
      }
    })
  }

  const onContinue = () => {

    const allSeatSelected = isAllSeatSelected(booking);
    if (allSeatSelected) {
      continueToCheckout();
      return;
    }

    messageBox.current.show()
    .then(() => {
      continueToCheckout();
    })
    .catch(() => {
      console.log('canceled')
    });
  }


  // render()

  const currencyCode = booking.currencyCode;
  const formattedAmount = numberFormatter.decimalSplitter(booking.reservationBalance);

  const inAppBrowser = isInAppBrowser();

  const mobileClass = inAppBrowser ? "in-mobile min-height" : "min-height";

  const rSeatPage = ls.t('SeatPage');
  if (!rSeatPage.Title) return null;
  const rButton = ls.t('Button');
  const rCommon = ls.t('Common');

  const allSeatSelected = isAllSeatSelected(booking);

  return (
    <div className={ls.t("rootClass") + " main-container"} dir={ls.t("direction")}>
      <div className="header-con">
        <Header hasSummary={true} />
      </div>
      <Backdrop />
      {!inAppBrowser && <StatusBar label="seats" onItemClick={item => jumpTo(item)} />}
      <div className="container padt40 padb40 seat-page">
        <div className={mobileClass}>
          <h1>{rSeatPage.Title}</h1>
          <SeatSelection
            key={`${booking.pnr}-${seatMaps.length}`}
            currencyCode={currencyCode}
            segments={booking.segments}
            passengers={booking.passengers}
            seatMaps={seatMaps}
            onClearSeat={onClearSeat}
            onAssignSeat={onAssignSeat}
            chooseSeatText={rSeatPage.RandomSeat.Text} />

          <div className="clearfix btnCon">
            {!inAppBrowser && <Button type="submit"
              className="btn btn-primary pull-left flip btn-cancel btn-effect"
              onClick={() => jumpTo(getAgentPath() + "/wci/passenger")}>
              <span><i className="picon picon-btn-arrow-left-w" />{rButton.Back}</span>
            </Button>}
            <Button type="submit"
              className="btn btn-primary pull-right flip btn-submit btn-effect"
              onClick={() => onContinue()}><span>{rButton.Continue }
                <i className="picon picon-btn-arrow-right-w" /></span>
            </Button>
            <div className="bottom-total pull-right">
              <label>{rCommon.BookingTotal}</label>
              <p>
                <span className="currency">
                  {bookingSummary.currencyCode}
                </span>
                {formattedAmount.amount}
                <span className={`${bookingSummary.currencyCode} decimal-point`}>
                  {
                    numberFormatter.oneDecimalPoint(formattedAmount.decimal, bookingSummary.currencyCode)
                  }
                </span>
              </p>
            </div>
          </div>
          {!allSeatSelected && <div className="tw-flex tw-justify-end tw-items-start">{rSeatPage.RandomSeat.Desc}</div> }
        </div>
      </div>
      {!inAppBrowser && <Footer />}
      <MessageBox ref={messageBox} />
    </div>
  );
}

function mapStateToProps(state) {

  return {
    bookingSummary: state.booking.summary,
    booking: state.booking.details,
  };
}

const mapDispatchToProps = {
  ...wciActions,
  getBookingWithSummary: bookingActions.getBookingWithSummary,

};

export default connect(mapStateToProps, mapDispatchToProps)(SeatsPage);

